import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import {
	failureMessage,
	successMessage
} from '../Notifications/notificationsSlice';

import {
	signUpForNewsletter,
	signUpForNewsletterCompleted,
	signUpForNewsletterFailed
} from './newsletterSlice';

export const signUpForNewsletterEpic = (action$) =>
	action$.pipe(
		ofType(signUpForNewsletter.type),
		mergeMap(async (action) => {
			try {
				const signUpForNewsletter = await axios.post(
					`${primaryApi()}/api/v1/newsletter/signup`,
					{ email: action.payload }
				);

				return signUpForNewsletter.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [
				signUpForNewsletterCompleted(res),
				successMessage('Thank you for signing up for our newsletter') // TODO: use Translate on this one.
			];
		}),
		catchError((error, source) => {
			return merge(
				of(
					signUpForNewsletterFailed(error.message),
					failureMessage(error.message)
				),
				source
			);
		})
	);

export default [signUpForNewsletterEpic];
